import Service from './abstract';

class Vu extends Service {
    constructor () {
        super('vu');
    }

    health () {
        const options = {
            url: `${this.basePath}`
        };

        return super.get(options);
    }
}

export default new Vu();
